<template>
  <div
    class="testimonial-area si-without-border-radius ptb-100 position-relative z-1"
  >
    <div class="container">
      <div class="section-title mw-1015 m-auto text-center" data-cues="zoomOut">
        <span class="top-title">آراء عملائنا</span>
        <h2>رضا عملائنا وثقتهم هي سر استمرارنا وتميزنا</h2>
        <p>
          التقييمات تتحدث عن نفسها! عملائنا يعشقون ثبات البث وجودة السيرفرات تماماً كما نحرص نحن عليها.
        </p>
      </div>
    </div>

    <div class="container-fluid p-md-0 overflow-hidden">
      <Swiper
        :slidesPerView="1"
        :spaceBetween="50"
        :loop="true"
        :centeredSlides="true"
        :preventClicks="true"
        :autoplay="{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }"
        :breakpoints="{
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          },
          1600: {
            slidesPerView: 4.5,
          },
        }"
        :modules="modules"
        class="testomonial-slide"
      >
        <SwiperSlide v-for="(testimonial, index) in testimonials" :key="index">
          <div :class="['testimonial-single-item', testimonial.styleClass]">
            <ul class="ps-0 list-unstyled d-flex gap-1">
              <li v-for="star in 5" :key="star">
                <i class="ri-star-fill"></i>
              </li>
            </ul>
            <h3>{{ testimonial.name }}</h3>
            <p>{{ testimonial.message }}</p>
          </div>
        </SwiperSlide>
      </Swiper>

      <div
        class="d-flex justify-content-between align-items-center google-review flex-wrap"
        data-cues="zoomOut"
      >
        <div class="d-flex align-items-center">
          <img src="@/assets/images/google.png" alt="google" />
          <p>التقييم العام <span>4.9</span></p>
        </div>
        <a href="https://wa.me/447429916178" target="_blank" class="read-more text-grey-teal">
          <span>اشترك وتواصل معنا الآن</span>
          <i class="ti ti-arrow-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation } from "swiper/modules";

export default defineComponent({
  name: "OurTestimonial",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const testimonials = ref([
      {
        name: "أبو محمد",
        message:
          "السيرفر ممتاز وثابت جداً، تابعت عليه البطولات الكبرى كاملة وبدون أي تقطيع أثناء أوقات الضغط العالي. أنصح بالتعامل معهم بشدة.",
        styleClass: "",
      },
      {
        name: "أحمد العلي",
        message:
          "أود أن أشكر الدعم الفني على احترافيتهم العالية وسرعة تجاوبهم معي في تفعيل الاشتراك وإعداد التطبيقات على شاشتي الذكية.",
        styleClass: "two",
      },
      {
        name: "خالد منصور",
        message:
          "مكتبة الأفلام والمسلسلات ضخمة جداً والتحديثات فيها يومية مع ترجمة احترافية وجودة فائقة. تجربة ممتازة وتستحق خمس نجوم.",
        styleClass: "two",
      },
      {
        name: "سلطان العتيبي",
        message:
          "جربت الكثير من السيرفرات سابقاً، ولكن هذا السيرفر تفوق عليها جميعاً من حيث الثبات والسرعة أثناء المباريات الجماهيرية.",
        styleClass: "",
      },
      {
        name: "أبو محمد",
        message:
          "السيرفر ممتاز وثابت جداً، تابعت عليه البطولات الكبرى كاملة وبدون أي تقطيع أثناء أوقات الضغط العالي. أنصح بالتعامل معهم بشدة.",
        styleClass: "",
      },
      {
        name: "أحمد العلي",
        message:
          "أود أن أشكر الدعم الفني على احترافيتهم العالية وسرعة تجاوبهم معي في تفعيل الاشتراك وإعداد التطبيقات على شاشتي الذكية.",
        styleClass: "two",
      },
      {
        name: "خالد منصور",
        message:
          "مكتبة الأفلام والمسلسلات ضخمة جداً والتحديثات فيها يومية مع ترجمة احترافية وجودة فائقة. تجربة ممتازة وتستحق خمس نجوم.",
        styleClass: "two",
      },
      {
        name: "سلطان العتيبي",
        message:
          "جربت الكثير من السيرفرات سابقاً، ولكن هذا السيرفر تفوق عليها جميعاً من حيث الثبات والسرعة أثناء المباريات الجماهيرية.",
        styleClass: "",
      },
    ]);

    return {
      modules: [Autoplay, Navigation],
      testimonials,
    };
  },
});
</script>